<template>
  <div class="col-12 row m-0 p-0 align-items-center">
    <div class="col-12 col-md-6 m-0 row div_center" style="height: 250px">
      <div class="cust_card div_center" @click="GoAction('Restaurant')">
        <img :src="require('@/assets/icon/訂位.png')" class="cust_card_icon" />
        <label class="m-0 ml-3" style="color: #ec6c00; font-size: 2rem; font-weight: 600">餐廳介紹、訂位</label>
      </div>
    </div>
    <div class="col-12 col-md-6 m-0 row div_center" style="height: 250px">
      <div class="cust_card div_center" @click="GoAction('MealMenu')">
        <img :src="require('@/assets/icon/Meal_record.png')" class="cust_card_icon" />
        <label class="m-0 ml-3" style="color: #ec6c00; font-size: 2rem; font-weight: 600">訂餐</label>
      </div>
    </div>
    <div class="col-12 col-md-6 m-0 row div_center" style="height: 250px">
      <div class="cust_card div_center" @click="GoAction('MealCustom')">
        <img :src="require('@/assets/icon/Meal_record.png')" class="cust_card_icon" />
        <label class="m-0 ml-3" style="color: #ec6c00; font-size: 2rem; font-weight: 600">活動客製餐點</label>
      </div>
    </div>
  </div>
</template>
<script>
import checkLoginMixin from '@/mixins/checkLoginMixin';
export default {
  name: 'OrderOrReservation',
  components: {},
  mixins: [checkLoginMixin],
  data() {
    return {
      queryData: [],
      Supl: [],
      IS_ON_FIRST_PAGE: true
    };
  },
  watch: {},
  mounted() {
    // this.queryData = JSON.parse(
    //   this.$Global.Base64Utils.atou(this.$route.query.value)
    // );
    this.init();
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    GoAction(name) {
      if (name == 'reservation') {
        if (this.Supl.Link_reservation != '' && this.Supl.Link_reservation != null && this.Supl.Link_reservation != undefined) {
          window.open(this.Supl.Link_reservation);
        }
      }
      else {
        this.$router.push({
          name: name
        });
      }
    },
    async init() {
      await this.checktoken();
      const CheckUserInfo = await this.GetUserInfo();
      //console.log(CheckUserInfo)
      if (CheckUserInfo == false) {
        //console.log('AAA')
        this.$parent.Msg('取得使用者資訊錯誤', '5', 'warning');
      }
      //this.GetSuplById();
    },
    GetSuplById() {
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            SuplNO: this.queryData
          })
        )
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.GetSuplById,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          if (data.length > 0) {
            this.Supl = data[0];
            console.log(this.Supl)
          }
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },
  }
};
</script>
<style scoped>
.Main_css {
  background-color: #faf7f2;
}

.cust_card_icon {
  width: 65px;
  height: 57px;
}

.cust_card {
  /* padding: 15px 50px 15px 50px; */
  border: 2px solid #f5b57f;
  background-color: white;
  border-radius: 0.5rem;
  height: 200px;
  width: 100%;
  max-width: 400px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Meal/OrderOrReservation.vue